import React from 'react'
import { IconSeekers } from 'ui-seeker/core'
import { formatPercentage, currencyInfoByCode, formatPrice } from 'ui-seeker/utils'
import CountUp from "react-countup"
import { AppTooltip } from 'app/@components'

export default function AppCard({ data, isMainHotelCard= false, currency = null, isPercentage = false, showDiffValue = true, tooltip = '' }) {
    const { label, diff, value } = data
    const currencyConfig = currency ? currencyInfoByCode(currency) : {}
    const diffClass = !!diff ? (diff < 0 ? 'diff-success' : 'diff-error') : ''

    const formatValue = () => {
        if (isPercentage) return !!value ? <CountUp end={value} suffix="%" /> : formatPrice(value)
        return !!value ? <CountUp end={value} {...currencyConfig} /> : formatPrice(value)
    }

    const content = (
        <div className="app-card__text-panel h-full flex flex-col">
            <div className="app-card__text-panel-header">
                <p className="app-card__text-panel-label">{label}</p>
                {!!tooltip && <IconSeekers style={{fontSize: '15px'}} icon="info-circle" iconType="fontAwesome"/>}
            </div>
        </div>
    )

    return <div style={{ height: '95px' }} className={`app-card ${isMainHotelCard && diff > 0 ? 'app-card--error' : ''}`}>
        {tooltip ? (
            <AppTooltip title={tooltip} placement="right">
                {content}
            </AppTooltip>
        ) : content}
        <div className="app-card__price-panel flex-1 flex flex-col justify-center">
            <span className="app-card__price-panel-value">
                <p className="app-card__text-panel-subtitle">Average Price</p>
                {formatValue()}
                {!!diff && (
                    <span className={`app-card__price-panel-diff ${diffClass}`}>
                        {showDiffValue && (
                            <span className="app-card__price-panel-diff-value">
                                {formatPercentage(diff, { decimals: 2 })}
                            </span>
                        )}
                        <IconSeekers
                            className="app-card__price-panel-diff-icon"
                            icon={diff < 0 ? 'arrow-down' : 'arrow-up'}
                            iconType="fontAwesome"
                            iconWeight='fa'
                        />
                    </span>
                )}
            </span>
        </div>
    </div>
}
